var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCommentsBlue = function SvgIconCommentsBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-comments"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M129.074 136.8h-6a9 9 0 0 0-2 17.77v6.23l7-6h1a9 9 0 1 0 0-18Z",
    transform: "translate(-114.074 -136.799)",
    fill: "#BEE6FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M127.074 148.8h-6a1 1 0 0 1 0-2h6a1 1 0 1 1 0 2Z",
    transform: "translate(-114.074 -136.799)",
    fill: "#2980B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M131.074 144.8h-10a1 1 0 0 1 0-2h10a1 1 0 1 1 0 2Z",
    transform: "translate(-114.074 -136.799)",
    fill: "#2980B9"
  }))));
};
export { SvgIconCommentsBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZyBpZD0iaWNvbi1jb21tZW50cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+CiAgICA8cGF0aCBpZD0iUGF0aF8xMTYiIGRhdGEtbmFtZT0iUGF0aCAxMTYiIGQ9Ik0xMjkuMDc0LDEzNi44aC02YTksOSwwLDAsMC0yLDE3Ljc3djYuMjNsNy02aDFhOSw5LDAsMSwwLDAtMThaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE0LjA3NCAtMTM2Ljc5OSkiIGZpbGw9IiNCRUU2RkEiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzExNyIgZGF0YS1uYW1lPSJQYXRoIDExNyIgZD0iTTEyNy4wNzQsMTQ4LjhoLTZhMSwxLDAsMCwxLDAtMmg2YTEsMSwwLDEsMSwwLDJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE0LjA3NCAtMTM2Ljc5OSkiIGZpbGw9IiMyOTgwQjkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzExOCIgZGF0YS1uYW1lPSJQYXRoIDExOCIgZD0iTTEzMS4wNzQsMTQ0LjhoLTEwYTEsMSwwLDAsMSwwLTJoMTBhMSwxLDAsMSwxLDAsMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTQuMDc0IC0xMzYuNzk5KSIgZmlsbD0iIzI5ODBCOSIvPgogIDwvZz4KPC9zdmc+Cg==";